import { render, staticRenderFns } from "./PendingIcon.vue?vue&type=template&id=a0fba18c"
import script from "./PendingIcon.vue?vue&type=script&lang=js"
export * from "./PendingIcon.vue?vue&type=script&lang=js"
import style0 from "./PendingIcon.vue?vue&type=style&index=0&id=a0fba18c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports